import React, { useState } from 'react'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import PropTypes from 'prop-types'
import DeactivateAccountForm from '../../../components/Form/DeactivateAccountForm/DeactivateAccountForm'
import FormattedMessage from '../../../components/FormattedMessage/FormattedMessage'

const DeactivateAccountSection = ({ user, onDeactivate }) => {
  const [modal, setModal] = useState(false)

  const deactivateUser = async ({ password }) => {
    const { email } = user
    const credentials = { email, password }
    await onDeactivate(credentials)
    return window.location.reload()
  }

  const toggleModal = () => {
    setModal(!modal)
  }

  return (
    <div>
      <div className="row justify-content-center py-4">
        <div className="col-md-8 col-xl-6">
          <Button
            name="deactivateAccountSubmitBtn"
            type="submit"
            outline
            color="secondary"
            size="sm"
            onClick={toggleModal}
            block
            aria-label="Deactivate Account"
          >
            <FormattedMessage id="page.myAccountPage.deactivate.title" />
          </Button>
        </div>
      </div>
      <Modal
        isOpen={modal}
        toggle={toggleModal}
        className="deactivate-account-modal"
        size="lg"
        aria-labelledby="deactivate-account-modal-title"
      >
        <ModalHeader toggle={toggleModal} id="deactivate-account-modal-title" />
        <ModalBody>
          <DeactivateAccountForm onSubmit={deactivateUser} onCancel={toggleModal} />
        </ModalBody>
      </Modal>
    </div>
  )
}

DeactivateAccountSection.propTypes = {
  user: PropTypes.object.isRequired,
  onDeactivate: PropTypes.func.isRequired,
}

export default DeactivateAccountSection
